module.exports = __webpack_public_path__ + "static/media/cheque-gris.667ae550.png";